import { convertUtcToLocal } from "../../utils/functions";

export const CBidCommonColumns = [
    {
      Header: "REQUEST_TIME",
      accessor: "REQUEST_TIME",
      sort: false,
      Cell: ({ row }: any) =>
        `${convertUtcToLocal(row.original.REQUEST_TIME, "DD/MM/YYYY HH:mm:ss")}`,
    },
    {
      Header: "USER_ID",
      accessor: "USER_ID",
      sort: false,
      Cell: ({ row }: any) =>
        `${
          row.original.USER_ID
            ? row.original.USER_ID.split(".").length > 1
              ? row.original.USER_ID.split(".")[1]
              : row.original.USER_ID.split(".")[0]
            : ""
        }`,
    },
    {
      Header: "USER_ID_HASHED",
      accessor: "USER_ID_HASHED",
      sort: false,
    },
    {
      Header: "DOMAIN",
      accessor: "DOMAIN",
      sort: false,
    },
    {
      Header: "APP_BUNDLE",
      accessor: "APP_BUNDLE",
      sort: false,
    },
    {
      Header: "APP_NAME",
      accessor: "APP_NAME",
      sort: false,
    },
    {
      Header: "DEVICE_IP",
      accessor: "DEVICE_IP",
      sort: false,
    },
    {
      Header: "IPV6_ADDRESS",
      accessor: "IPV6_ADDRESS",
      sort: false,
    },
    {
      Header: "DEVICE_BROWSER",
      accessor: "DEVICE_BROWSER",
      sort: false,
    },
    {
      Header: "DEVICE_MAKE",
      accessor: "DEVICE_MAKE",
      sort: false,
    },
    {
      Header: "DEVICE_MODEL",
      accessor: "DEVICE_MODEL",
      sort: false,
    },
    {
      Header: "DEVICE_TYPE",
      accessor: "DEVICE_TYPE",
      sort: false,
    },
    {
      Header: "DEVICE_OS",
      accessor: "DEVICE_OS",
      sort: false,
    },
    {
      Header: "DEVICE_OSV",
      accessor: "DEVICE_OSV",
      sort: false,
    },
    {
      Header: "GEO_COUNTRY",
      accessor: "GEO_COUNTRY",
      sort: false,
    },
    {
      Header: "GEO_LAT",
      accessor: "GEO_LAT",
      sort: false,
    },
    {
      Header: "GEO_LON",
      accessor: "GEO_LON",
      sort: false,
    },
    {
      Header: "PAGE_URL",
      accessor: "PAGE_URL",
      sort: false,
    },
    {
      Header: "DEVICE_UA",
      accessor: "DEVICE_UA",
      sort: false,
    },
    {
      Header: "ENVIRONMENT_TYPE",
      accessor: "ENVIRONMENT_TYPE",
      sort: false,
    },
  ];
  
  export const CBidAdminColumns = [
    {
      // 1. Date (Optional to sort by date, default is from new to old) [timestamp] - split
      Header: "REQUEST_TIME",
      accessor: "REQUEST_TIME",
      sort: false,
      Cell: ({ row }: any) =>
        `${convertUtcToLocal(row.original.REQUEST_TIME, "DD/MM/YYYY HH:mm:ss")}`,
    },
    {
      // 2. Time (Optional to sort by time, default is from new to old) [timestamp] - split
      Header: "USER_ID",
      accessor: "USER_ID",
      sort: false,
      Cell: ({ row }: any) =>
        `${
          row.original.USER_ID
            ? row.original.USER_ID.split(".").length > 1
              ? row.original.USER_ID.split(".")[1]
              : row.original.USER_ID.split(".")[0]
            : ""
        }`,
    },
    {
      Header: "USER_ID_HASHED",
      accessor: "USER_ID_HASHED",
      sort: false,
    },
    {
      // 3. URL [url]
      Header: "USER_ID_TYPE",
      accessor: "USER_ID_TYPE",
      sort: false,
    },
    {
      // 3. URL [url]
      Header: "DOMAIN",
      accessor: "DOMAIN",
      sort: false,
    },
    {
      // 4. Referrer [referrer]
      Header: "APP_BUNDLE",
      accessor: "APP_BUNDLE",
      sort: false,
    },
    {
      // 5. Client Type [clientType]
      Header: "APP_NAME",
      accessor: "APP_NAME",
      sort: false,
    },
    {
      // 6. Client Type [clientType]
      Header: "DEVICE_IP",
      accessor: "DEVICE_IP",
      sort: false,
    },
    {
      // 6. Client Type [clientType]
      Header: "IPV6_ADDRESS",
      accessor: "IPV6_ADDRESS", ////////************** */
      sort: false,
    },
    {
      // 7. Client Name [clientName]
      Header: "APP_IAB_CATEGORY",
      accessor: "APP_IAB_CATEGORY",
      sort: false,
    },
    {
      // 8. Device Type [devicetype]
      Header: "DEVICE_LANGUAGE",
      accessor: "DEVICE_LANGUAGE",
      sort: false,
    },
    {
      // 9. Device Brand [deviceBrand]
      Header: "DEVICE_BROWSER",
      accessor: "DEVICE_BROWSER",
      sort: false,
    },
    {
      // 10. Device Model [deviceModel]
      Header: "DEVICE_IFA",
      accessor: "DEVICE_IFA",
      sort: false,
    },
    {
      // 11. OS Name [osName]
      Header: "DEVICE_MAKE",
      accessor: "DEVICE_MAKE",
      sort: false,
    },
    {
      // 12. userAgent [userAgent]
      Header: "DEVICE_MODEL",
      accessor: "DEVICE_MODEL",
      sort: false,
    },
    {
      // 13. userAgent [userAgent]
      Header: "DEVICE_TYPE",
      accessor: "DEVICE_DEVICETYPE",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "DEVICE_OS",
      accessor: "DEVICE_OS",
      sort: false,
      // width:900,
      // minWidth: 500,
    },
    {
      // 14. OS Version [osVersion]
      Header: "DEVICE_OSV",
      accessor: "DEVICE_OSV",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "GEO_COUNTRY",
      accessor: "GEO_COUNTRY",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "GEO_TYPE",
      accessor: "GEO_TYPE",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "GEO_LAT",
      accessor: "GEO_LAT",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "GEO_LON",
      accessor: "GEO_LON",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "PAGE_URL",
      accessor: "PAGE_URL",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "DEVICE_UA",
      accessor: "DEVICE_UA",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "CARRIER_CODE",
      accessor: "CARRIER_CODE",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "ENVIRONMENT_TYPE",
      accessor: "ENVIRONMENT_TYPE",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "INVENTORY_SOURCE",
      accessor: "INVENTORY_SOURCE",
      sort: false,
    },
    {
      Header: "CONTENT_LANGUAGE",
      accessor: "CONTENT_LANGUAGE",
      sort: false,
    },
    {
      Header: "INSERT_TIMESTAMP",
      accessor: "INSERT_TIMESTAMP",
      sort: false,
    },
    {
      Header: "DATA_CENTER",
      accessor: "DATA_CENTER",
      sort: false,
    },
    {
      Header: "INVENTORY_SOURCE_USER_ID",
      accessor: "INVENTORY_SOURCE_USER_ID",
      sort: false,
    },
    {
      Header: "PUBLISHER_NAME",
      accessor: "PUBLISHER_NAME",
      sort: false,
    },
  ];